<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="input-group"
        role="group"
        :class="
            cn(
                'bg-background-primary p-[16px]',
                'group/input-group border-input relative flex w-full items-center rounded-xl border shadow-xs transition-[color,box-shadow] outline-none',
                'h-12 min-w-0 has-[>textarea]:h-auto',

                // Variants based on alignment.
                'has-[>[data-align=inline-start]]:[&>input]:pl-2',
                'has-[>[data-align=inline-end]]:[&>input]:pr-2',
                'has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3',
                'has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3',

                // Focus state.
                'has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-border-highlighted has-[[data-slot=input-group-control]:focus-visible]:ring-2',

                // Error state.
                'has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive',

                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
